<script>
import pagination from "@/mixins/pagination";
import CommonTableComponent from "@/components/table.vue";
import tableSearch from "@/mixins/tableSearch";
import apiEndpoints from "@/services/apiEndpoints";
import CommandStatus from "@/views/pages/dashboard/modals/CommandStatus.vue"
import router from "@/mixins/router";

export default {
  name: "notification",
  mixins: [pagination, tableSearch,router],
  components: {
    CommonTableComponent,
    CommandStatus,
  },
  data() {
    return {
      filters: {
        page: 1,
        column: this.$route.query.column || "delivery_date",
        dir: this.$route.query.dir || "DESC"
      },
      busyGetData: false,
      notifications: [],
      specialNotifications: [],
      result_per_page: this.$constant.max_records_per_page,
      isExpanded: false,
    };
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      const response = await this.$http.get(apiEndpoints.top_notification_manifest, {
        ...this.filters,
      });
      const {status, data} = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        const resultData = this.$_.isEmpty(result.data) ? [] : result.data;
          this.notifications = resultData.filter(
            item => !['04', '07', '22'].includes(String(item.zz_top_message_id)) || 
            String(item.zz_top_message_id) === '05' && [
              '最終処分終了報告確認期限切れ通知（排出宛）',
              '最終処分終了報告確認期限切れ通知（処分宛）'
            ].includes(item.substitution_string)
          );
          this.specialNotifications = resultData.filter(
            item => ['04', '07', '22'].includes(String(item.zz_top_message_id)) || 
            String(item.zz_top_message_id) === '05' && [
              '最終処分終了報告確認期限切れ通知（排出宛）',
              '最終処分終了報告確認期限切れ通知（処分宛）'
            ].includes(item.substitution_string)
          );
        const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        this.setMeta(meta);
      };
    },
    updateUrlFilters() {
      this.getData()
    },
    toggleItem() {
      this.isExpanded = !this.isExpanded;
    },
    getMessageJwnError(item) {
      return item?.top_message.replace('{0}', `<span class="cursor-pointer" style="color:#0576b9" id="tooltip-target-${item.id}">[${item.jwn_error_code}]</span>`)
    }
  },
  watch: {
    'filters.page': {
      immediate: false,
      handler() {
        this.getData();
      },
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "引渡日/通知日",
          value: "delivery_date",
          sortable: true,
          width: 10,
          additionalClasses: "delivery_date"
        },
        {
          text: "マニフェスト番号",
          value: "manifest_number",
          sortable: true,
          width: 10,
          additionalClasses: "manifest_number"
        },
        {
          text: "機能番号",
          value: "control_number",
          sortable: true,
          width: 10,
          additionalClasses: "control_number"
        },
        {
          text: "1次/2次",
          value: "manifest_stage",
          sortable: true,
          width: 10,
          additionalClasses: "manifest_stage"
        },
        {
          text: "事業者",
          value: "discharger",
          sortable: true,
          width: 10,
          additionalClasses: "discharger"
        },
        {
          text: "事業場",
          value: "discharger_site",
          sortable: true,
          width: 10,
          additionalClasses: "discharger_site"
        },
        {
          text: "内容",
          value: "top_message",
          sortable: true,
          width: 30,
          additionalClasses: "top_message"
        },
        {
          text: "期限日",
          value: "due_date",
          sortable: true,
          width: 10,
          additionalClasses: "due_date"
        },
      ];
    },
  },
};
</script>

<template>
  <div class="row">
    <b-overlay
      :show="busyGetData"
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block"
    >

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div
              @click="toggleItem()"
              v-b-toggle.collapse-notification
              class="card-title mb-2 mt-2"
            >
              <span class="font-size-16">マニフェスト警告通知（{{ notifications.length }}件）</span>
              <span :class="{'rotate': isExpanded}" class="icon">▼</span>
            </div>
            <b-collapse id="collapse-notification">
              <CommandStatus modal-id="modal-command-status-notifications"
                command-type="notifications"/>
              <CommonTableComponent
               :height-class="`table-wrapper-500`"
               :scrollAble="notifications.length >= this.$constant.scroll_able_records">
                <thead class="table-light">
                <tr>
                  <th
                    :style="`width: ${item.width}`"
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                  >
                    <span v-if="item.sortable" @click="clickSort(item.value)">
                      {{ item.text }}
                      <i :class="getSortClass(item.value)"></i>
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr 
                v-for="(item, index) in notifications" 
                :key="index"
                @click="
                redirectRoute(
                  'manifests.edit',
                  { id: item.manifest_id },                  
                )
                "
                >
                  <td>
                    {{ item.delivery_date }}
                  </td>
                  <td>
                    {{ item.manifest_number }}
                  </td>
                  <td>
                    {{ item.control_number }}
                  </td>
                  <td>
                    {{ item.manifest_stage }}
                  </td>
                  <td>
                    {{ item.discharger_name_abbreviated }}
                  </td>
                  <td>
                    {{ item.discharger_site_name_abbreviated }}
                  </td>
                  <td v-if="item.zz_top_message_id == '05' && !item.jwn_error_description">
                    {{ item.top_message.replace('{0}', item.substitution_string) }}
                  </td>
                  <td v-else-if="item.zz_top_message_id == '06' && item.jwn_error_description">
                    <span @click.stop>
                    <div v-html="getMessageJwnError(item)"></div>
                    </span>
                    <b-tooltip
                      placement="bottom"
                      :target="`tooltip-target-${item.id}`"
                      triggers="click"
                    >
                      {{ item.jwn_error_description }}
                    </b-tooltip>
                  </td>
                  <td v-else-if="item.zz_top_message_id == '18'">
                    {{ item.top_message.replace('{0}', item.substitution_string) }}
                  </td>
                  <td v-else>
                    {{ item.top_message }}
                  </td>
                  <td>
                    {{ item.due_date }}
                  </td>
                </tr>
                <tr v-if="!notifications.length && !busyGetData">
                  <td colspan="7" class="text-center">
                    通知はありません
                  </td>
                </tr>
                </tbody>
              </CommonTableComponent>
            </b-collapse>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-body">
            <div
              @click="toggleItem()"
              v-b-toggle.collapse-specialNotifications
              class="card-title mb-2 mt-2"
            >
              <span class="font-size-16">最終処分報告関連の警告通知（{{ specialNotifications.length }}件）</span>
              <span :class="{'rotate': isExpanded}" class="icon">▼</span>
            </div>
            <b-collapse id="collapse-specialNotifications">
              <CommandStatus modal-id="modal-command-status-specialNotifications"
                command-type="specialNotifications"/>
              <CommonTableComponent
               :height-class="`table-wrapper-500`"
               :scrollAble="notifications.length >= this.$constant.scroll_able_records">
                <thead class="table-light">
                <tr>
                  <th
                    :style="`width: ${item.width}`"
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                  >
                    <span v-if="item.sortable" @click="clickSort(item.value)">
                      {{ item.text }}
                      <i :class="getSortClass(item.value)"></i>
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr 
                v-for="(item, index) in specialNotifications" 
                :key="index"
                @click="
                redirectRoute(
                  'manifests.edit',
                  { id: item.manifest_id },                  
                )
                "
                >
                  <td>
                    {{ item.delivery_date }}
                  </td>
                  <td>
                    {{ item.manifest_number }}
                  </td>
                  <td>
                    {{ item.control_number }}
                  </td>
                  <td>
                    {{ item.manifest_stage }}
                  </td>
                  <td>
                    {{ item.discharger_name_abbreviated }}
                  </td>
                  <td>
                    {{ item.discharger_site_name_abbreviated }}
                  </td>
                  <td v-if="item.zz_top_message_id == '05' && !item.jwn_error_description">
                    {{ item.top_message.replace('{0}', item.substitution_string) }}
                  </td>
                  <td v-else-if="item.zz_top_message_id == '06' && item.jwn_error_description">
                    <span @click.stop>
                    <div v-html="getMessageJwnError(item)"></div>
                    </span>
                    <b-tooltip
                      placement="bottom"
                      :target="`tooltip-target-${item.id}`"
                      triggers="click"
                    >
                      {{ item.jwn_error_description }}
                    </b-tooltip>
                  </td>
                  <td v-else-if="item.zz_top_message_id == '18'">
                    {{ item.top_message.replace('{0}', item.substitution_string) }}
                  </td>
                  <td v-else>
                    {{ item.top_message }}
                  </td>
                  <td>
                    {{ item.due_date }}
                  </td>
                </tr>
                <tr v-if="!notifications.length && !busyGetData">
                  <td colspan="7" class="text-center">
                    通知はありません
                  </td>
                </tr>
                </tbody>
              </CommonTableComponent>
            </b-collapse>
          </div>
        </div>
      </div>
    </b-overlay> 
  </div>
</template>
<style scoped>
.icon {
  float: right;
  transition: transform 0.3s;
}
.rotate {
  transform: rotate(-90deg);
}
.delivery_date {
  width:8%;
  min-width:50px;
}
.control_number {
  width:5%;
  min-width:30px;
}
.manifest_number {
  width:10%;
  min-width:50px;
}
.manifest_stage {
  width:5%;
  min-width:50px;
}
.discharger {
  width:20%;
  min-width:100px;
}
.discharger_site {
  width:20%;
  min-width:100px;
}
.top_message {
  width:30%;
  min-width:70px;
}
.due_date {
  width:8%;
  min-width:50px;
}
</style>
